import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ModalService } from '../services/modal.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslateModule],
  template: `
    <header class="fixed top-0 w-full z-50 bg-dark-100/90 backdrop-blur-lg border-b border-white/[0.04]">
      <div class="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <a href="#" class="flex items-center gap-1 group">
          <img src="logo.png" alt="COLORFOL" class="h-6" />
        </a>
        
        <nav class="hidden md:flex items-center gap-7">
          <a href="#problem" class="text-gray-550 hover:text-white transition-colors text-[13px] font-medium">{{ 'HEADER.WHY' | translate }}</a>
          <a href="#model" class="text-gray-550 hover:text-white transition-colors text-[13px] font-medium">{{ 'HEADER.HOW' | translate }}</a>
          <a href="#features" class="text-gray-550 hover:text-white transition-colors text-[13px] font-medium">{{ 'HEADER.FEATURES' | translate }}</a>
          <a href="#pricing" class="text-gray-550 hover:text-white transition-colors text-[13px] font-medium">{{ 'HEADER.PRICING' | translate }}</a>
        </nav>
        
        <div class="flex items-center gap-4">
          <!-- Language Switcher -->
          <div class="flex items-center gap-1 bg-white/[0.03] rounded-full p-1 border border-white/[0.06]">
            <button (click)="switchLang('en')" 
                    [class.bg-white]="currentLang === 'en'" [class.text-dark-100]="currentLang === 'en'" [class.text-gray-500]="currentLang !== 'en'" 
                    class="px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider rounded-full transition-all">
              EN
            </button>
            <button (click)="switchLang('fr')" 
                    [class.bg-white]="currentLang === 'fr'" [class.text-dark-100]="currentLang === 'fr'" [class.text-gray-500]="currentLang !== 'fr'" 
                    class="px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider rounded-full transition-all">
              FR
            </button>
          </div>
          
          <button (click)="modalService.openComingSoon($event)" class="bg-primary text-white px-5 py-2 rounded-full text-[13px] font-bold hover:bg-primary-dark transition-colors">
            {{ 'HEADER.START' | translate }}
          </button>
        </div>
      </div>
    </header>
  `
})
export class HeaderComponent {
  modalService = inject(ModalService);
  currentLang: string;

  constructor(private translate: TranslateService) {
    this.currentLang = this.translate.currentLang || this.translate.getDefaultLang() || 'en';
    this.translate.onLangChange.subscribe(event => {
      this.currentLang = event.lang;
    });
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }
}
